<template>
  <div
    :style="
      `color: white; background-color:${bgColor}; border-radius: 12px; padding: 8px 22px; font-size: 14px; ${styleCustom}`
    "
  >
    {{ message }}
  </div>
</template>

<script>
export default {
  props: {
    bgColor: {
      type: String,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    styleCustom: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>
